import { render } from "./DocumentiFiscali.vue?vue&type=template&id=ac80f176&scoped=true"
import script from "./DocumentiFiscali.vue?vue&type=script&lang=js"
export * from "./DocumentiFiscali.vue?vue&type=script&lang=js"

import "./DocumentiFiscali.vue?vue&type=style&index=0&id=ac80f176&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac80f176"]])

export default __exports__